import './applied_keywords_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedPostKeywordView extends Monitoring.Views.SocialContents.Filters.AppliedKeywordsView

  removeFilter: (value, list) ->
    @searchQuery.removePostPrimaryKeyword(value)   if list == @withPrefix('primary_keywords')
    @searchQuery.removePostSecondaryKeyword(value) if list == @withPrefix('secondary_keywords')
    @searchQuery.removePostExcludedKeyword(value)  if list == @withPrefix('excluded_keywords')

  withPrefix: (search_query_field) ->
    "post_#{search_query_field}"
